export default __webpack_public_path__ + "static/media/aim.5899823e.jfif";